module.exports = __webpack_public_path__ + "img/96.383be090.jpg";